var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"stats"},_vm._l((_vm.getDefaultPizzaSizes),function(size){return _c('div',{key:size.id},[_c('strong',[_vm._v(" "+_vm._s(size.name)+" ")]),_vm._v(" $ "+_vm._s(size.price)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }